import React, { useMemo, useState } from 'react';

import SubmitButton, { SubmitButtonProps } from '../elements/formElements/SubmitButton';

type BlockingSubmitProps = Omit<SubmitButtonProps, 'isBusy'>;

/* eslint-disable react/jsx-props-no-spreading */

export default function useBlockingSubmit(
    autoBlock = true
): [React.FC<BlockingSubmitProps>, React.Dispatch<React.SetStateAction<boolean>>, boolean] {
    const [isLoading, setLoading] = useState(false);

    function BlockingSubmit(props: BlockingSubmitProps) {
        return (
            <SubmitButton
                {...(props as SubmitButtonProps)}
                isLoading={isLoading}
                onClick={(event) => {
                    if (autoBlock) {
                        const { form } = event.currentTarget;
                        const setDisabledAttribute = () => {
                            setLoading(true);
                            form.removeEventListener('submit', setDisabledAttribute);
                        };

                        form?.addEventListener('submit', setDisabledAttribute);
                    }

                    if (props.onClick) {
                        props.onClick(event);
                    }
                }}
            />
        );
    }

    return [useMemo(() => BlockingSubmit, [isLoading]), setLoading, isLoading];
}
